import DashboardGrid from '@/components/dashboard/dashboard-grid/dashboard-grid';
import Resources from '@/components/resources/resources';
import TestingSummaryCard from '@/components/testing-summary-card/testing-summary-card';
import { Box, Flex, Text } from '@cmpsr/components';
import React from 'react';
import EmptyState from './components/empty-state/empty-state';
import useTestingPlanController from './your-testing-plan.controller';

function YourTestingPlan() {
  const { recommendations } = useTestingPlanController();

  if (!recommendations || !recommendations.length) return <EmptyState />;

  return (
    <DashboardGrid>
      <Box as="main">
        <Text variant="text-header-M" mb={5}>
          Recommended Tests
        </Text>
        <Flex direction="column" gap={{ base: 4, lg: 8 }}>
          {recommendations.map((testData, index) => (
            <TestingSummaryCard screeningTypeData={testData} key={`${testData.id}-${index}`} />
          ))}
        </Flex>
      </Box>
      <Resources as="aside" width="full" />
    </DashboardGrid>
  );
}

export default React.memo(YourTestingPlan);
